/**
 * DeliveryVisitEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90001
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { VisitEntity } from "../VisitEntity";
import { DeliveryVisitEntity } from "../DeliveryVisitEntity";
declare global {
    interface EntityTypeMap {
        DeliveryVisit: DeliveryVisitEntity;
    }
}
export abstract class DeliveryVisitGeneratedEntity extends BaseEntity {
    public abstract deliveryVisitId: string;
    public abstract templateId: string | null;
    public abstract keysDelivered: number | null;
    public abstract keysTotal: number | null;
    public abstract gasMeter: number | null;
    public abstract electricMeter: number | null;
    public abstract waterMeter: number | null;
    public abstract visit: VisitEntity;
}
